import React from 'react';


export default function FileDownloadButton({ fileBlob, getFile, fileName = 'file', buttonName='Скачать файл' }) {
    const [loading, setLoading] = React.useState(false);
    const isProcessingRef = React.useRef(false);

    const handleDownload = React.useCallback(async () => {
        if (isProcessingRef.current) return;
        isProcessingRef.current = true;
        setLoading(true);

        let objectUrl = null;
        let createdUrl = false;

        try {
            let source = fileBlob;

            if (getFile) {
                source = await getFile();
            }

            if (!source) {
                throw new Error('Файл не передан');
            }

            if (source instanceof Blob) {
                objectUrl = URL.createObjectURL(source);
                createdUrl = true;
            } else {
                objectUrl = source;
            }

            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error('Ошибка скачивания файла:', err);
        } finally {
            if (createdUrl && objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
            setLoading(false);
            isProcessingRef.current = false;
        }
    }, [fileBlob, getFile, fileName]);

    return (
        <button
            className='button'
            onClick={handleDownload}
            disabled={loading}
            aria-busy={loading}
        >
            {loading ? (
                <span>Загрузка...</span>
            ) : (
                <>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="download-alt">
                        <path fill="#fff" d="M8.29,13.29a1,1,0,0,0,0,1.42l3,3a1,1,0,0,0,1.42,0l3-3a1,1,0,0,0-1.42-1.42L13,14.59V3a1,1,0,0,0-2,0V14.59l-1.29-1.3A1,1,0,0,0,8.29,13.29ZM18,9H16a1,1,0,0,0,0,2h2a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H8A1,1,0,0,0,8,9H6a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V12A3,3,0,0,0,18,9Z"></path>
                    </svg>
                    {buttonName}
                </>
            )}
        </button>
    );
}
